/** @format */

import { jwtDecode } from "jwt-decode";

/**
 * Checks if a JWT token is expired and removes it from localStorage if it is
 *
 * @returns {boolean} - Returns true if token was expired and removed, false otherwise
 */
export const checkTokenExpiry = () => {
   const token = localStorage.getItem("token");

   if (!token) {
      return false;
   }

   try {
      // Decode the JWT token
      const payload = jwtDecode(token);

      // Check if token has an expiration claim
      if (!payload.exp) {
         // Token doesn't have expiration claim, consider it valid
         return false;
      }

      // exp is in seconds, convert to milliseconds for comparison
      const expirationTime = payload.exp * 1000;
      const currentTime = Date.now();

      // Check if token is expired
      if (currentTime >= expirationTime) {
         // Token is expired, remove it from localStorage
         localStorage.removeItem("token");
         window.location.reload();
         return true;
      }

      return false;
   } catch (error) {
      // If there's an error decoding the token (invalid format, etc.), remove it
      console.error("Error checking token expiry:", error);
      localStorage.removeItem("token");
      return true;
   }
};
